import { CommonResponse } from './../models/responses/common-response';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from './request.service';
import { IPermission } from '../models/permission';
import { LocalStorageEnum } from '../models/enums/local-storage.enum';
import { LocalStorageService } from './local-storage.service';
import { PERMISSION } from '../models/enums/permission.enum';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private permissions: string[] | undefined;

  constructor(
    private requestService: RequestService,
    private _localStorageService: LocalStorageService
  ) {}

  GetPermissions(): string[] {
    if (this.permissions == undefined || this.permissions.length <= 0) {
      this.permissions = this._localStorageService.getArrays(
        LocalStorageEnum.permissions
      );
    }
    return this.permissions;
  }

  public getPermission(
    page: number,
    count: number,
    search?: string
  ): Observable<CommonResponse<IPermission>> {
    return this.requestService.getJSON<IPermission>(`/permissions`, {
      data: Object.assign({ page, count, search }),
      option: {
        is_loading: true,
      },
    });
  }

  public getPermissionByID(
    id: string
  ): Observable<CommonResponse<IPermission>> {
    return this.requestService.getJSON<IPermission>(`/permissions/${id}`, {
      data: {},
      option: {
        is_loading: true,
      },
    });
  }

  public createPermission(data: any) {
    return this.requestService.postJSON<any>(
      `/permissions/create`,
      {
        data: Object.assign(data),
        option: {
          is_loading: true,
        },
      },
      true
    );
  }

  public updatePermission(
    data: any,
    id: string
  ): Observable<CommonResponse<IPermission>> {
    return this.requestService.patchJSON<any>(
      `/permissions/${id}/update`,
      {
        data: Object.assign(data),
        option: {
          is_loading: true,
        },
      },
      true
    );
  }

  activeToogle(id: string, data: any): Observable<any> {
    const path = `/permissions/${id}/update`;
    return this.requestService.patchJSON<any>(path, {
      data,
      option: {
        is_loading: true,
      },
    });
  }
  currentUserPermission() {
    let permissions = this._localStorageService.getArray(
      LocalStorageEnum.permissions
    );
    return {
      dashboard: {
        is_allow_read: !!permissions.includes(PERMISSION.READ_DASHBOARD),
      },
      nssf_request: {
        is_allow_create: !!permissions.includes(
          PERMISSION.ALLOW_CREATE_NSSF_USER
        ),
        is_allow_edit: !!permissions.includes(PERMISSION.ALLOW_EDIT_NSSF_USER),
        is_allow_disable: !!permissions.includes(
          PERMISSION.ALLOW_DISABLE_NSSF_USER
        ),
      },
      hospital_request: {
        is_allow_read: !!permissions.includes(
          PERMISSION.HOSPITAL_CONTRACT_READ
        ),
        // is_allow_register: !!permissions.includes(PERMISSION.ALLOW_REGISTER_HOS_REQ),
        is_allow_approved: !!permissions.includes(
          PERMISSION.HOSPITAL_CONTRACT_APPROVAL
        ),
        // is_allow_return: !!permissions.includes(PERMISSION.ALLOW_RETURN_HOS_REQ),
        // is_allow_reject: !!permissions.includes(PERMISSION.ALLOW_REJECT_HOS_REQ),
        is_allow_edit: !!permissions.includes(
          PERMISSION.HOSPITAL_CONTRACT_WRITE
        ),

        is_allow_register_read: !!permissions.includes(
          PERMISSION.REGISTER_HOSPITAL_READ
        ),
        is_allow_register_edit: !!permissions.includes(
          PERMISSION.REGISTER_HOSPITAL_WRITE
        ),
      },

      hospital: {
        is_allow_read: !!permissions.includes(PERMISSION.HOSPITAL_READ),
        is_allow_edit: !!permissions.includes(PERMISSION.HOSPITAL_WRITE),
      },

      hospital_contract: {
        is_allow_read: !!permissions.includes(
          PERMISSION.HOSPITAL_CONTRACT_READ
        ),
        is_allow_create: !!permissions.includes(
          PERMISSION.HOSPITAL_CONTRACT_WRITE
        ),
        is_allow_approved: !!permissions.includes(
          PERMISSION.HOSPITAL_CONTRACT_APPROVAL
        ),
        // is_allow_return: !!permissions.includes(PERMISSION.ALLOW_RETURN_HOSPITAL_CONTRACT),
        // is_allow_reject: !!permissions.includes(PERMISSION.ALLOW_REJECT_HOSPITAL_CONTRACT),
      },

      hospital_non_contract: {
        // is_allow_read: !!permissions.includes(PERMISSION.READ_HOSPITAL_NON_CONTRACT),
        // is_allow_edit: !!permissions.includes(PERMISSION.ALLOW_EDIT_HOSPITAL_NON_CONTRACT),
        // is_allow_create: !!permissions.includes(PERMISSION.ALLOW_EDIT_HOSPITAL_NON_CONTRACT),
      },

      hospital_contract_case: {
        is_allow_read: !!permissions.includes(
          PERMISSION.HOSPITAL_CONTRACT_CASE_READ
        ),
        is_allow_create: !!permissions.includes(
          PERMISSION.HOSPITAL_CONTRACT_CASE_WRITE
        ),
        // is_allow_edit: !!permissions.includes(PERMISSION.ALLOW_EDIT_HOSPITAL_CONTRACT_CASE),
        // is_allow_active: !!permissions.includes(
        //   PERMISSION.ALLOW_ACTIVE_HOSPITAL_CONTRACT_CASE
        // ),
      },

      hospital_bank_account: {
        is_allow_read: !!permissions.includes(PERMISSION.HOSPITAL_READ),
        is_allow_create: !!permissions.includes(PERMISSION.HOSPITAL_WRITE),
      },

      pharmacy_request: {
        is_allow_read: !!permissions.includes(PERMISSION.PAYMENT_REQUEST_READ),
        // is_allow_register: !!permissions.includes(PERMISSION.ALLOW_REGISTER_PHARMACY_REQ),
        is_allow_approved: !!permissions.includes(
          PERMISSION.PAYMENT_REQUEST_APPROVAL
        ),
        // is_allow_return: !!permissions.includes(PERMISSION.ALLOW_RETURN_PHARMACY_REQ),
        // is_allow_reject: !!permissions.includes(PERMISSION.ALLOW_REJECT_PHARMACY_REQ),
        is_allow_edit: !!permissions.includes(PERMISSION.PAYMENT_REQUEST_WRITE),
      },

      pharmacy: {
        is_allow_read: !!permissions.includes(PERMISSION.PHARMACY_READ),
        is_allow_create: !!permissions.includes(PERMISSION.PHARMACY_WRITE),
      },

      pharmacy_contract: {
        is_allow_read: !!permissions.includes(
          PERMISSION.PHARMACY_CONTRACT_READ
        ),
        is_allow_create: !!permissions.includes(
          PERMISSION.PHARMACY_CONTRACT_WRITE
        ),
        is_allow_approved: !!permissions.includes(
          PERMISSION.PHARMACY_CONTRACT_APPROVAL
        ),
        // is_allow_return: !!permissions.includes(PERMISSION.ALLOW_RETURN_PHARMACY_CONTRACT),
        // is_allow_reject: !!permissions.includes(PERMISSION.ALLOW_REJECT_PHARMACY_CONTRACT),
      },

      pharmacy_user: {
        is_allow_read: !!permissions.includes(PERMISSION.PHARMACY_USER_READ),
        // is_allow_create: !!permissions.includes(PERMISSION.ALLOW_CREATE_PHARMACY_USER),
        is_allow_edit: !!permissions.includes(PERMISSION.PHARMACY_USER_WRITE),
      },

      automatic_approval: {
        approval_config: {
          // is_allow_read: !!permissions.includes(PERMISSION.READ_AUTO_APPROVAL_CONFIGS),
          // is_allow_create: !!permissions.includes(PERMISSION.ALLOW_CREATE_AUTO_APPROVAL_CONFIGS),
          // is_allow_edit: !!permissions.includes(PERMISSION.ALLOW_EDIT_AUTO_APPROVAL_CONFIGS),
          // is_allow_disable: !!permissions.includes(PERMISSION.ALLOW_DISABLE_AUTO_APPROVAL_CONFIGS),
        },
        approval_audit_log: {
          // is_allow_read: !!permissions.includes(PERMISSION.READ_AUTO_APPROVAL_AUDITLOGS),
        },
      },

      hospital_consumption: {
        patient_form: {
          is_allow_read: !!permissions.includes(
            PERMISSION.PATIENT_PRINT_FORM_READ
          ),
          is_allow_close: !!permissions.includes(
            PERMISSION.PATIENT_PRINT_FORM_CLOSE
          ),
        },

        beneficiary: {
          // is_allow_read: !!permissions.includes(PERMISSION.READ_BEN),
          // is_allow_scan: !!permissions.includes(PERMISSION.ALLOW_SCAN_BEN),
          // is_allow_print: !!permissions.includes(PERMISSION.ALLOW_PRINT_BEN),
          // is_allow_e_print: !!permissions.includes(PERMISSION.ALLOW_E_PRINT_BEN),

          is_allow_read: !!permissions.includes(PERMISSION.BENEFICIARY_READ),
          is_allow_scan: !!permissions.includes(
            PERMISSION.BENEFICIARY_PRINT_PATIENT_FORM
          ),
          is_allow_print: !!permissions.includes(
            PERMISSION.BENEFICIARY_PRINT_EMERGENCY
          ),
        },
        hos_con_req: {
          // is_allow_read: !!permissions.includes(PERMISSION.READ_CON_REQ),
          // is_allow_create: !!permissions.includes(PERMISSION.ALLOW_CREATE_CON_REQ),
          // is_allow_approved: !!permissions.includes(PERMISSION.ALLOW_APPROVE_CON_REQ),
          // is_allow_return: !!permissions.includes(PERMISSION.ALLOW_RETURN_CON_REQ),
          // is_allow_reject: !!permissions.includes(PERMISSION.ALLOW_REJECT_CON_REQ),

          is_allow_read: !!permissions.includes(PERMISSION.CONSUMPTION_READ),
          is_allow_create: !!permissions.includes(PERMISSION.CONSUMPTION_WRITE),
          is_allow_approved: !!permissions.includes(
            PERMISSION.CONSUMPTION_APPROVAL
          ),
        },
        claim_req: {
          is_allow_read: !!permissions.includes(
            PERMISSION.CLAIM_REQUEST_HOS_READ
          ),
          is_allow_create: !!permissions.includes(
            PERMISSION.CLAIM_REQUEST_HOS_WRITE
          ),
          is_allow_approved: !!permissions.includes(
            PERMISSION.CLAIM_REQUEST_HOS_APPROVAL
          ),
          // is_allow_return: !!permissions.includes(PERMISSION.ALLOW_RETURN_CLAIM_REQ),
          // is_allow_reject: !!permissions.includes(PERMISSION.ALLOW_REJECT_CLAIM_REQ),
          // is_allow_assign: !!permissions.includes(PERMISSION.ALLOW_ASSIGN_CLAIM_REQ),
          // is_allow_verify_detail: !!permissions.includes(PERMISSION.ALLOW_VERIFY_CLAIM_REQ_DETAIL),
        },
        claim_req_hos: {
          is_allow_read: !!permissions.includes(
            PERMISSION.CLAIM_REQUEST_HOS_READ
          ),
          is_allow_create: !!permissions.includes(
            PERMISSION.CLAIM_REQUEST_HOS_WRITE
          ),
          is_allow_approved: !!permissions.includes(
            PERMISSION.CLAIM_REQUEST_HOS_APPROVAL
          ),
        },
        claim_req_nssf: {
          is_allow_read: !!permissions.includes(
            PERMISSION.CLAIM_REQUEST_NSSF_READ_ALL
          ),
          is_allow_read_nssf: !!permissions.includes(
            PERMISSION.CLAIM_REQUEST_NSSF_READ_ASSIGN_ONLY
          ),
          is_allow_assign: !!permissions.includes(
            PERMISSION.CLAIM_REQUEST_NSSF_ASSIGN
          ),
          is_allow_approved: !!permissions.includes(
            PERMISSION.CLAIM_REQUEST_NSSF_APPROVAL
          ),
          is_allow_payment: !!permissions.includes(
            PERMISSION.CLAIM_REQUEST_NSSF_MAKE_PAYMENT
          ),
        },
        payment_req: {
          is_allow_create: !!permissions.includes(
            PERMISSION.PAYMENT_REQUEST_READ
          ),
          is_allow_read: !!permissions.includes(
            PERMISSION.PAYMENT_REQUEST_WRITE
          ),
          is_allow_approved: !!permissions.includes(
            PERMISSION.PAYMENT_REQUEST_APPROVAL
          ),
          is_allow_print: !!permissions.includes(
            PERMISSION.PAYMENT_REQUEST_PRINT
          ),
        },
        transmittal_req: {
          is_allow_read: !!permissions.includes(
            PERMISSION.TRANSMITTAL_LETTER_READ
          ),
          is_allow_create: !!permissions.includes(
            PERMISSION.TRANSMITTAL_LETTER_WRITE
          ),
          is_allow_approved: !!permissions.includes(
            PERMISSION.TRANSMITTAL_LETTER_PRINT
          ),
        },
        post_processing: {
          // is_allow_read: !!permissions.includes(PERMISSION.READ_POST_PROCESSING),
          // is_allow_edit: !!permissions.includes(PERMISSION.ALLOW_EDIT_POST_PROCESSING ),
          // is_allow_approved: !!permissions.includes(PERMISSION.ALLOW_APPROVE_POST_PROCESSING ),
          // is_allow_return: !!permissions.includes(PERMISSION.ALLOW_RETURN_POST_PROCESSING),
          // is_allow_reject: !!permissions.includes(PERMISSION.ALLOW_REJECT_POST_PROCESSING),
          // is_allow_assign: !!permissions.includes(PERMISSION.ALLOW_ASSIGN_POST_PROCESSING),
          // is_allow_verify_detail: !!permissions.includes(PERMISSION.ALLOW_VERIFY_POST_PROCESSING_DETAIL),
        },
      },

      setting: {
        is_allow_create: !!permissions.includes(
          PERMISSION.ALLOW_CREATE_SETTING
        ),
        is_allow_edit: !!permissions.includes(PERMISSION.ALLOW_EDIT_SETTING),
        is_allow_disable: !!permissions.includes(
          PERMISSION.ALLOW_DISABLE_SETTING
        ),
      },
      report: {
        hf_payment_report: {
          is_allow_read: !!permissions.includes(
            PERMISSION.READ_REPORT_HF_PAYMENT
          ),
        },
        hospital_report: {
          is_allow_read: !!permissions.includes(
            PERMISSION.READ_REPORT_HOSPITAL
          ),
        },
      },
    };
  }
}
